<template>
  <div>
    <b-container class="goback-button-container">
      <b-row class=" mt-5 d-flex justify-content-start">
          <b-col
              cols='4' md='2' 
              class="back-button btn btn-outline-danger"
              @click="goBack()"
          >          
            <span class="mt-1">Назад</span>
          </b-col>
      </b-row>           
    </b-container>

    <b-container class="feedback-container">
      <b-row no-gutters>
        <b-col>
          <h2 class="form-header mx-auto">{{'feedBackHeader' | localize}}</h2>
        </b-col>
      </b-row>
      <b-row no-gutters>
        
        <b-col 
          class="mx-auto" 
          cols="11" sm="11" md="10" lg="8" xl="8"
        >
          <form 
            class="feed-Back-Form-Center" 
            @submit.prevent="feedBack" 
            novalidate
          >     
          <div class="new-address-description">{{'feedBackTheme' | localize}}:</div>
            <b-form-select 
              class="mb-1"  
              v-model="feed_back_theme" 
              :options="options"
            >
              <template #first>
                <b-form-select-option 
                  :value="null"
                   disabled
                >
                  {{'feedBackHead' | localize}}
                </b-form-select-option>
              </template>
            </b-form-select>
          <div 
              class="form-description-error"
              v-if="$v.feed_back_theme.$dirty && !$v.feed_back_theme.required"
          >
              {{'newAddressRequiredInput' | localize}}
          </div> 
          <div class="new-address-description">{{'feedBackText' | localize}}</div>
          <b-form-textarea
            class="mb-3"
            id="textarea"
            v-model="feebBack_text"
            placeholder="Текст обращения"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
          <div 
              class="form-description-error"
              v-if="$v.feebBack_text.$dirty && !$v.feebBack_text.required"
          >
              {{'newAddressRequiredInput' | localize}}
          </div> 
          <div class="new-address-description">{{'feedBackFile' | localize}}</div>
          <b-form-file
            v-model="file"
            placeholder="Выберите файл"
            drop-placeholder="Drop file here..."
          ></b-form-file>
          <b-button 
            type="submit"
            class="mt-5 mb-3 style-button button-profile-width"
            variant="outline-danger"
          >
              {{'feedBackButtonSubmit' | localize}} <div class="style-button-icon"> <b-icon  icon="chat-square-dots" ></b-icon> </div> 
          </b-button>
            </form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required} from 'vuelidate/lib/validators'
export default {
  mixins: [validationMixin],
  name: 'feedBack',
  validations: {
    feebBack_text: { required },
    feed_back_theme: { required },
  },
  data: ()=> ({
    options: [],
    file: null,
    file64: null,
    feebBack_text: '',
    user_id: null,
    feed_back_theme: null,
    feed_back_data: null
  }),
  async mounted(){
    localStorage.setItem('weltumLastUrl', window.location.pathname)
    await this.$store.dispatch('departmentsList')
    this.user_id = window.location.pathname.split('/').pop()
    this.departmentDataInfo()
  },
  computed: mapGetters(['departmentsData', 'locale']),
  methods: {
    departmentDataInfo(){
      let themes = []
      this.departmentsData.forEach(element => {
        let item = {
          value: element.id,
          text: element.name
        }
        themes.push(item)
        this.options = themes
      });
    },
    goBack(){
      this.$router.go(-1)
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
     feedBack(){
      if(this.$v.$invalid){
        this.$v.$touch()
      } else {
        if(this.file == null){
            const feed_back_data = {
              schet: this.user_id,
              otd: this.feed_back_theme,
              mess: this.feebBack_text,
              name_f: "",
              content_f: "",
              secret_key: localStorage.weltumKey
            }
            
            this.$store.dispatch('sendFeedBackForm', feed_back_data).then(()=>{this.feebBack_text = ''; this.file = null})
        } else {
          this.getBase64(this.file).then(
            data => {
              const file64 = data.split(',')[1];
              const feed_back_data = {
                schet: this.user_id,
                otd: this.feed_back_theme,
                mess: this.feebBack_text,
                name_f: this.file.name,
                content_f: file64,
                secret_key: localStorage.weltumKey
              }
              this.$store.dispatch('sendFeedBackForm', feed_back_data).then(()=>{this.feebBack_text = ''; this.file = null})

            }
          ); 
        }
        this.$messageLocalized("messageSent")
      }
    }
}
}
</script>
